import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLog: [],
  totalLog: 0,
};
const slice = createSlice({
  name: "workflowLog",
  initialState,
  reducers: {
    getActionLog() {},
    getActionLogSuccess(state, action) {
      state.listLog = action.payload;
    },
    updateTotalLog(state, action) {
      state.totalLog = action.payload;
    },
  },
});
export default slice.reducer;

export const { getActionLog, getActionLogSuccess, updateTotalLog } =
  slice.actions;
